"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AddSubjectsToReviewCycleMetadataSchema () {
        return AddSubjectsToReviewCycleMetadataSchema;
    },
    get CreateReviewCycleMetadataSchema () {
        return CreateReviewCycleMetadataSchema;
    },
    get ExportCompanyMeetingsMetadataSchema () {
        return ExportCompanyMeetingsMetadataSchema;
    },
    get ExportWorkspaceMeetingsMetadataSchema () {
        return ExportWorkspaceMeetingsMetadataSchema;
    },
    get GenerateReviewCycleInsightsMetadataSchema () {
        return GenerateReviewCycleInsightsMetadataSchema;
    },
    get GenerateSurveyInsightsMetadataSchema () {
        return GenerateSurveyInsightsMetadataSchema;
    },
    get ProcessDocumentEmbeddingsMetadataSchema () {
        return ProcessDocumentEmbeddingsMetadataSchema;
    },
    get RegenerateSyntheticEmailsMetadataSchema () {
        return RegenerateSyntheticEmailsMetadataSchema;
    },
    get getMetadataSchemaForTask () {
        return getMetadataSchemaForTask;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _model = require("./model");
const objectId = _zod.z.instanceof(_bson.ObjectId);
const ExportCompanyMeetingsMetadataSchema = _zod.z.object({
    filters: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    sort: _zod.z.object({
        name: _zod.z.string(),
        direction: _zod.z.enum([
            "asc",
            "desc"
        ])
    }).optional(),
    timezone: _zod.z.string(),
    signedUrl: _zod.z.string().optional()
});
const ExportWorkspaceMeetingsMetadataSchema = _zod.z.object({
    workspaceId: _zod.z.string(),
    filters: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    timezone: _zod.z.string(),
    signedUrl: _zod.z.string().optional()
});
const GenerateReviewCycleInsightsMetadataSchema = _zod.z.object({
    reviewCycleId: _zod.z.string(),
    promptHash: _zod.z.string(),
    parentLogId: _zod.z.string(),
    retry: _zod.z.boolean()
});
const GenerateSurveyInsightsMetadataSchema = _zod.z.object({
    surveyId: _zod.z.string(),
    promptHash: _zod.z.string(),
    parentLogId: _zod.z.string(),
    retry: _zod.z.boolean()
});
const ProcessDocumentEmbeddingsMetadataSchema = _zod.z.object({
    documentId: _zod.z.string(),
    filename: _zod.z.string()
});
const AddSubjectsToReviewCycleMetadataSchema = _zod.z.object({
    cycleId: _zod.z.string(),
    companyId: _zod.z.string(),
    userId: _zod.z.string(),
    adminsOnly: _zod.z.boolean(),
    startDate: _zod.z.string(),
    assignments: _zod.z.array(_zod.z.record(_zod.z.string(), _zod.z.unknown())),
    userSelectionId: _zod.z.string(),
    groupId: _zod.z.string().optional()
});
/**
 * Cycle creation data stored in task metadata.
 * Matches IReviewCycleInvocationData consumed by the create-review-cycle lambda.
 */ const CycleInvocationData = _zod.z.object({
    _id: objectId,
    name: _zod.z.string(),
    creator: objectId,
    department: objectId.nullable(),
    user_selection: _zod.z.array(objectId),
    company: objectId,
    template: objectId,
    assignments: _zod.z.array(_zod.z.record(_zod.z.string(), _zod.z.unknown())),
    admins_only: _zod.z.boolean(),
    workflow: _zod.z.object({
        _id: objectId,
        name: _zod.z.string(),
        forms: _zod.z.array(_zod.z.record(_zod.z.string(), _zod.z.unknown())),
        company: objectId
    }),
    start_date: _zod.z.date(),
    easy_add_configs: _zod.z.array(objectId),
    is_automated: _zod.z.boolean().optional(),
    timezone: _zod.z.string()
});
const CreateReviewCycleMetadataSchema = _zod.z.object({
    cycleId: _zod.z.string(),
    cycleData: CycleInvocationData,
    autoflow: _zod.z.object({
        enabled: _zod.z.boolean(),
        resourceId: objectId,
        companyId: objectId
    }).passthrough().optional()
});
const RegenerateSyntheticEmailsMetadataSchema = _zod.z.object({
    companyId: _zod.z.string(),
    triggeredByUserId: _zod.z.string(),
    oldFieldId: _zod.z.string().nullable(),
    newFieldId: _zod.z.string()
});
const getMetadataSchemaForTask = (taskName)=>{
    switch(taskName){
        case _model.ASYNC_TASK_NAMES.EXPORT_COMPANY_MEETINGS_CSV:
            return ExportCompanyMeetingsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.EXPORT_WORKSPACE_MEETINGS_CSV:
            return ExportWorkspaceMeetingsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.GENERATE_REVIEW_CYCLE_INSIGHTS:
            return GenerateReviewCycleInsightsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.GENERATE_SURVEY_INSIGHTS:
            return GenerateSurveyInsightsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.PROCESS_DOCUMENT_EMBEDDINGS:
            return ProcessDocumentEmbeddingsMetadataSchema;
        case _model.ASYNC_TASK_NAMES.ADD_SUBJECTS_TO_REVIEW_CYCLE:
            return AddSubjectsToReviewCycleMetadataSchema;
        case _model.ASYNC_TASK_NAMES.CREATE_REVIEW_CYCLE:
            return CreateReviewCycleMetadataSchema;
        case _model.ASYNC_TASK_NAMES.REGENERATE_SYNTHETIC_EMAILS:
            return RegenerateSyntheticEmailsMetadataSchema;
        default:
            // Exhaustiveness check
            const _exhaustive = taskName;
            throw new Error(`Unknown task name: ${_exhaustive}`);
    }
};
